//*** -- Keep `require` and `module.exports` over `import` for Santa Worker (Felix) -- ***

const {createViewerScript} = require('./createViewerScript');

module.exports = createViewerScript;
